import { BaseEventBuilder } from '@droidmap/shared-service-contract'

import {
  CreatePhotogrammetryTaskEventInput,
  Task,
  TaskDeletedEventInput,
} from '../models/task.js'

const serviceSource = 'droidmap.backend.project-service'

export const TaskCreated = new BaseEventBuilder<Task, 'Task Created'>(
  serviceSource,
  'Task Created',
)

export const TaskDeleted = new BaseEventBuilder<
  TaskDeletedEventInput,
  'Task Deleted'
>(serviceSource, 'Task Deleted')

export const TaskUpdated = new BaseEventBuilder<Task, 'Task Updated'>(
  serviceSource,
  'Task Updated',
)

export const CreatePhotogrammetryTask = new BaseEventBuilder<
  CreatePhotogrammetryTaskEventInput,
  'Create Photogrammetry Task'
>(serviceSource, 'Create Photogrammetry Task')

export const RequestAssetSetDeletion = new BaseEventBuilder<
  { assetSetId: string },
  'Request asset set deletion'
>(serviceSource, 'Request asset set deletion')
